// React import
import React from 'react';
// Styles imports
import './AiAnalytics.css';
import '../../util.css'

class AiAnalytics extends React.Component {

    render () {
        return(
            <div className={"ai-analytics noselect"}>
                <span className={"ai-analytics-text"}>
                    AI features<br/>coming soon
                </span>
            </div>
        );
    }

}

export default AiAnalytics;